import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchUsers = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
      ...(filters.level && { level: filters.level }),
    });

    const response = await axios.get(`${BASE_URL_BE}/user?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paket:", error);
    throw error;
  }
};

export const createUser = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/user`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateUser = async (idUser, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/user/${idUser}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};


// Di frontend Anda (file service)

export const updateByEmail = async (idUser, payload) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/user/byemail/${idUser}`, payload.data, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

  export const totalUser = async () => {
    try {
      const response = await axios.get(`${BASE_URL_BE}/user/total`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting soal:", error);
      throw error;
    }
  };



export const deleteUser = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/user/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};




export const fetchUsersRegis = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
      ...(filters.level && { level: filters.level }),
    });

    const response = await axios.get(`${BASE_URL_BE}/user/regis?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paket:", error);
    throw error;
  }
};
